document.addEventListener("DOMContentLoaded", () => {
  // Get the elements
  const burgerButton = document.querySelector(".navbar-burger");
  const menu = document.querySelector(".navbar-menu");
  const backdrop = document.querySelector(".navbar-backdrop");
  const closeButton = document.querySelector(".navbar-menu-close");

  // Bind event listeners
  burgerButton.addEventListener("click", openMenu);
  closeButton.addEventListener("click", closeMenu);
  document.addEventListener("click", handleClickOutside);

  function openMenu(event) {
    event.stopPropagation();
    menu.classList.add("show");
    backdrop.classList.add("show");
  }

  function closeMenu(event) {
    menu.classList.remove("show");
    backdrop.classList.remove("show");
  }

  function handleClickOutside(event) {
    if (menu.classList.contains("show") && !menu.contains(event.target)) {
      closeMenu(event);
    }
  }

  if (window.location.pathname.includes("/course")) {
    // const gallery = document.querySelector(".gallery");
    // const lightbox = document.getElementById("lightbox");
    // const lightboxImage = document.getElementById("lightbox-image");
    // const clsButton = document.getElementById("gclose");
    // // Add event listener to each image
    // gallery.addEventListener("click", (e) => {
    //   if (e.target.classList.contains("gallery-image")) {
    //     const imageSrc = e.target.src;
    //     lightboxImage.src = imageSrc;
    //     lightbox.style.display = "flex";
    //   }
    // });
    // // Close lightbox when close button is clicked
    // clsButton.addEventListener("click", () => {
    //   lightbox.style.display = "none";
    // });
    // // Close lightbox when clicking outside the image
    // lightbox.addEventListener("click", (e) => {
    //   if (e.target === lightbox) {
    //     lightbox.style.display = "none";
    //   }
    // });
  }
});
